import { apiClient } from "services/api/client";
import { ICommonDateRanges } from "services/api/types";

export const getCommonDateRanges = async () => {
  const url = "shared/commonDateRanges";
  const response = await apiClient.get<{ ranges: ICommonDateRanges }>(url);
  return response.data;
};
